var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLoading)?_c('v-progress-linear',{staticClass:"bionic-loading-bar",attrs:{"indeterminate":true,"color":"success"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }